angular.module('qkr')
        .controller('MenuEditController', ($scope, $rootScope, $uibModalInstance, menu, isNewMenu, isSharedMenu,
                                           existingMenuTypes, imageService, merchantService, departmentService,
                                           FormHelper, utils, $uibModal, menuService, messageService, gettextCatalog,
                                           appConfig) => {
            const vm = $scope;
            const formHelper = new FormHelper($scope);

            vm.isDepartmentManager = appConfig.isDepartmentManager;
            vm.newMenu = isNewMenu;
            vm.sharedMenu = isSharedMenu;
            vm.holder = {};
            vm.holder.detailsExpanded = true;
            vm.holder.availabilityExpanded = false;
            vm.holder.menuAlwaysAvailable = false;
            vm.currentMenu = menu;
            vm.isPos = merchantService.merchantInfo.posType ? true : false;
            vm.form = {};
            vm.form.fullImageUrl = '';
            vm.form.menuSubsidised = false;
            vm.isMerchantEnableSubsidisedProduct = merchantService.behaviour(merchantService.merchantInfo,
                'editMenuPage.showMenuSubsidised');
            vm.isCharityMenu = merchantService.behaviour(merchantService.merchantInfo, 'editMenuPage.charityMenu');

            vm.days = utils.getDaysOfWeekWithSelected();
            vm.menuTypes = ['PAY_AT_TABLE', 'ORDER_AT_TABLE', 'COLLECTION', 'DELIVERY', 'REWARD', 'DONATION', 'OTHER',
                'BAR_TAB'];
            vm.defaultSelection = vm.isCharityMenu ? 'DONATION' : (vm.isPos ? 'PAY_AT_TABLE' : 'COLLECTION');

            vm.menu = {};
            vm.menu.menuType = menu.type;

            vm.menuTypes = vm.menuTypes.filter(function (el) {
                return existingMenuTypes.indexOf(el) < 0;
            });

            vm.tabs = {
                details: true,
                availability: false
            };

            // Perform some simple client side validation
            vm.validateForm = function () {
                // Empty the errors list
                vm.errors = null;
                let valid = true;
                const errors = {};

                if ((appConfig.businessCategory === 'School' || appConfig.businessCategory === 'University') &&
                    !vm.display.menuType) {
                    errors.menuType = gettextCatalog.getString('Please select a Menu type');
                    vm.holder.detailsExpanded = true;
                    valid = false;
                    vm.swapTabs(true, false);
                } else {
                    // For fixed menus ensure both dates are set
                    if (vm.display.menuType == 'fixed') {
                        const cutOffDate = vm.display.orderEndDate;
                        const endDate = vm.display.endDate;
                        if ((utils.hasNoValue(cutOffDate) && !utils.hasNoValue(endDate)) ||
                            (!utils.hasNoValue(cutOffDate) && utils.hasNoValue(endDate))) {
                            errors.fixedAvailability = gettextCatalog.getString('Please enter both a fulfilment date ' +
                                'and final date or leave both blank (individual products must then specify a date)');
                            valid = false;
                            vm.swapTabs(false, true);
                            vm.holder.availabilityExpanded = true;
                        } else if (!utils.hasNoValue(cutOffDate) && !utils.hasNoValue(endDate)) {
                            // Simply ensure cutoff is before the end date for the product
                            const cutoffend = new Date(cutOffDate);
                            const eventEnd = new Date(endDate);
                            eventEnd.setHours(23);
                            eventEnd.setMinutes(59);
                            eventEnd.setSeconds(59);
                            if (eventEnd < cutoffend) {
                                errors.fixedAvailability = gettextCatalog.getString('Order final date must be before the event date');
                                valid = false;
                                vm.swapTabs(false, true);
                                vm.holder.availabilityExpanded = true;
                            }
                        }
                    }
                    if (vm.display.menuType == 'recurring') {
                        // CUT OFF TIME

                        if (utils.hasNoValue(vm.display.cutOffTime)) {
                            errors.cutoff = gettextCatalog.getString('A cut-off time for orders must be selected');
                            valid = false;
                            vm.swapTabs(false, true);
                        }

                        // IS ALWAYS AVAILABLE
                        if (!vm.holder.menuAlwaysAvailable) {
                            // AT LEAST ONCE A WEEK
                            let hasDays = false;
                            angular.forEach(vm.days, (day) => {
                                if (day.selected) {
                                    hasDays = true;
                                }
                            });
                            if (!hasDays) {
                                errors.reccuringDays = gettextCatalog.getString('At least one day must be selected');
                                valid = false;
                                vm.swapTabs(false, true);
                            }
                        }
                    }
                }

                // Name is a required field
                if (!vm.uploadMenu.name) {
                    errors.name = gettextCatalog.getString('Please provide a name for the menu');
                    vm.holder.detailsExpanded = true;

                    valid = false;
                    vm.swapTabs(true, false);
                }

                vm.errors = errors;

                return valid;
            };

            vm.swapTabs = function (details, availability) {
                vm.tabs.availability = availability;
                vm.tabs.details = details;
            };

            // Expand or hide the top details section
            vm.expandHideDetails = function() {
                vm.holder.detailsExpanded = !vm.holder.detailsExpanded;
            };

            // Expand or hide the availability section
            vm.expandHideAvailability = function() {
                vm.holder.availabilityExpanded = !vm.holder.availabilityExpanded;
                if (vm.holder.availabilityExpanded && vm.holder.detailsExpanded) {
                    vm.holder.detailsExpanded = false;
                }
            };

            vm.changedAvailability = function() {
                if (vm.holder.availabilityExpanded && !vm.holder.menuAlwaysAvailable) {
                    setTimeout(() => {
                        const $id = $('#modalBody');
                        $id.scrollTop($id[0].scrollHeight);
                    }, 200);
                }
            };

            /*
             * Function to open the choose image modal dialog
             */
            vm.selectMenuImage = function($files) {
                imageService.editingImageReferenceName = 'MENU_' + Math.random();
                $rootScope.requiredAspectRatio = 1;
                $rootScope.scaledWidthAbsolute = 250;

                const modalInstance2 = $uibModal.open({
                    template: require('../../templates/imageUpload.html'),
                    controller: 'ImageController',
                    windowClass: 'modal-image  modal-borderless modal-small',
                    size: 'sm',
                    backdrop: 'static',
                    resolve: {
                        inputImage() {
                            return $files;
                        }
                    }

                });

                modalInstance2.result.then((selectedItem) => {
                    if (selectedItem !== 'cancel') {
                        vm.form.fullImageUrl = selectedItem.mediaValue + '?decache=' + new Date().getTime();
                        vm.form.imageUrl = selectedItem.mediaValue + '?decache=' + new Date().getTime();
                        // Currently a meu only has one media element - so replace this
                        // With this new value
                        // At some point we may want to support more in which case we
                        // May either append this new value
                        // Or replace an existing one if editing
                        vm.form.mediaElements = [{
                            id: selectedItem.id
                        }];
                    }
                });
            };
            // Is this menu always available?
            // Used to set a variable that is bound to the yes/no switch on the ui
            vm.alwaysAvailable = function() {
                if (utils.hasNoValue(vm.currentMenu.availability))
                    return true;

                if (!utils.hasNoValue(vm.currentMenu) && !utils.hasNoValue(vm.currentMenu.availability)) {
                    const av = angular.copy(vm.currentMenu.availability);

                    if (!utils.hasNoValue(av)) {
                        if (!utils.hasNoValue(av.expiryDateStr) || !utils.hasNoValue(av.blackoutDates)
                            || (!utils.hasNoValue(av.orderDays) && (av.orderDays.split(',').length != 7))
                            || (av.orderDays === '')) // Handle empty list of days                                                                                                                                                                                                    // empty
                            return false;
                    }
                }
                return true;
            };

            // Handle response from attempted save
            vm.saveMenuCallback = function(response) {
                const r = formHelper.handleResponse(response);
                if (r.isSuccess()) {
                    if (!vm.sharedMenu) {
                        menuService.loadMenus(departmentService.getCurrentDepId()).then((menuItemsResponse) => {
                            departmentService.clearDepartmentCache();
                            $rootScope.$broadcast('newMenus', menuItemsResponse);
                            vm.saving = false;
                            // Reload the dashboard info
                            $rootScope.$broadcast('reloadDashboard');

                            let newMenu = {};

                            for (let i = 0; i < menuItemsResponse.length; i++) {
                                if (vm.form.name == menuItemsResponse[i].name) {
                                    newMenu = menuItemsResponse[i];
                                    break;
                                }
                            }

                            $uibModalInstance.close(newMenu);
                            //                $modalInstance.close(response.data);

                            messageService.saveAlert();
                        });
                    } else {
                        $rootScope.$broadcast('newMenus', response);
                        vm.saving = false;
                    }
                } else {
                    vm.saving = false;
                    if(response.data.exception && !response.data.errors) {
                        response.data.errors = response.data.exception;
                    }
                    if (response.data && response.data.errors && response.data.errors.length > 0) {
                        messageService.error(response, null, true);
                    } else {
                        messageService.error(gettextCatalog
                            .getString('A problem was encountered when saving. Please try again.'));
                    }
                }
            };

            vm.changeMenuType = function () {
                if (vm.display.menuType === 'realtime') {
                    vm.tabs.details = false;
                } else {
                    vm.tabs.availability = true;
                }
            };

            function isMenuTypeFixedAndEndDateEmpty(display) {
                return (display.menuType === 'fixed' && !display.orderEndDate);
            }

            vm.isDatePickerEmpty = function () {

                if (isMenuTypeFixedAndEndDateEmpty(vm.display)) {
                    vm.display.cutOffTime = new Date().setHours('hh', 'mm', 'ss', 'ms');
                    return true;
                }
                return false
            };

            // Modify Menu format - setting variables as necessary to allow binding of
            // Display
            vm.transformForRendering = function () {
                vm.form = angular.copy(vm.currentMenu);
                if (vm.form == null) {
                    vm.form = {};
                }

                vm.form.fullImageUrl = imageService.fullImageUrl(vm.currentMenu.imageUrl);

                // Create the options that the display binds to
                vm.display = angular.copy(vm.form.options);
                if (utils.hasNoValue(vm.display)) {
                    vm.display = {};
                    vm.display.blackoutDateList = [];
                }
                if (utils.hasNoValue(vm.form.availability)) {
                    vm.form.availability = {};
                }
                vm.holder.menuAlwaysAvailable = vm.alwaysAvailable();

                if (!vm.newMenu) {
                    if ((appConfig.businessCategory === 'School' || appConfig.businessCategory === 'University'
                            || appConfig.businessCategory === 'Supplier')) {
                        vm.display.menuType = utils.getMenuType(vm.form);
                    } else {
                        vm.display.menuType = 'realtime';
                    }
                }

                if (vm.newMenu) {
                    vm.form.cancelForbidden = true;

                    vm.holder.menuAlwaysAvailable = true;
                    // For new menus we must do some hacky stuff -
                    // Check existing menus and based on that we restrict certain
                    // Parameters for the creation of this menu

                    if (!vm.sharedMenu) {
                        menuService.loadMenus(departmentService.getCurrentDepId()).then((promise) => {
                            vm.currentMenuList = menuService.menuList;
                            vm.form.requiresBeneficiary = merchantService.behaviour($rootScope.merchantInfo,
                                'requiresBeneficiary');
                        });
                    }

                    if (appConfig.businessCategory !== 'School' && appConfig.businessCategory !== 'University') {
                        vm.display.menuType = 'realtime';
                    }
                }

                if (!utils.hasNoValue(vm.form.availability)) {
                    if (!utils.hasNoValue(vm.form.availability.expiryDateStr)) {
                        vm.display.endDate = utils.serverDateStringtoDate(vm.form.availability.expiryDateStr);
                    }

                    if (!utils.hasNoValue(vm.form.availability.blackoutDates)) {
                        const bdl = vm.form.availability.blackoutDates.split(',');
                        vm.display.blackoutDateList = [];
                        for (var i = 0; i < bdl.length; i++) {
                            const dt = new Date(utils.serverDateToDate(bdl[i]));

                            vm.display.blackoutDateList.push(dt);
                        }
                    }
                    if (!utils.hasNoValue(vm.form.availability.orderDays)) {
                        for (var i = 0; i < vm.days.length; i++) {
                            vm.days[i].selected = vm.form.availability.orderDays.indexOf(vm.days[i].name) != -1;
                        }
                    }
                    // An empty string indicates that all days have been deselected
                    else if (vm.form.availability.orderDays === '') {
                        for (var i = 0; i < vm.days.length; i++) {
                            vm.days[i].selected = false;
                        }
                    }

                    if (!utils.hasNoValue(vm.form.availability.cutoffOffsetInMinutes)) {
                        // Sorry about the messy calculation
                        const cutoff = vm.form.availability.cutoffOffsetInMinutes;
                        let cutoffhrs = cutoff % 1440;
                        const rolloveroffset = cutoffhrs < 0 ? 24 * 60 : 0;
                        cutoffhrs = rolloveroffset + cutoffhrs;
                        const time_cutoff = cutoffhrs;
                        const time_cutoff_hours = Math.floor(time_cutoff / 60);
                        const time_cutoff_minutes = time_cutoff % 60;
                        const day_start = cutoff - time_cutoff;
                        const lead_time = Math.floor(Math.abs(cutoff * 1.0 / 1440.0)) + rolloveroffset / 1440;

                        vm.display.leadTime = lead_time;

                        if (vm.display.menuType === 'fixed') {
                            if (vm.display.endDate != null) {
                                vm.display.orderEndDate = angular.copy(vm.display.endDate);
                                vm.display.orderEndDate.setDate(vm.display.orderEndDate.getDate() - vm.display.leadTime);
                            }
                        }
                        const d = new Date();
                        d.setHours(time_cutoff_hours);
                        d.setMinutes(time_cutoff_minutes);
                        vm.display.cutOffTime = d;

                        if (vm.form.availability.cutoffOffsetInMinutes === 0) {
                            vm.display.cutOffTime = null;
                            vm.display.leadTime = null;
                        }
                    } else {
                        vm.display.cutOffTime = new Date();
                    }
                }
            };

            // Convert the json to the format expected in the server
            vm.transformForSaving = function () {
                const uploaded = angular.copy(vm.form);
                uploaded.type = vm.menu.menuType;

                uploaded.shared = vm.sharedMenu;

                if (utils.hasNoValue(uploaded.availability))
                    uploaded.availability = {};

                if (utils.hasNoValue(uploaded.orderDays))
                    uploaded.orderDays = [];

                if (vm.display.menuType == 'realtime') {
                    // Sending up an empty availability object
                    uploaded.availability.isPreorderable = false;
                    uploaded.availability.fixedPreorderType = false;
                } else {
                    // Fixed menu Type
                    if (vm.display.menuType == 'fixed') {
                        uploaded.availability.isPreorderable = true;
                        uploaded.availability.fixedPreorderType = true;

                        if (!utils.hasNoValue(vm.display.endDate))
                            uploaded.availability.expiryDateStr = utils.dateToServerDateString(vm.display.endDate);
                        else
                            uploaded.availability.expiryDateStr = null;

                        if (!utils.hasNoValue(vm.display.orderEndDate)) {
                            const oneDay = 24 * 60; // Hours*minutes*seconds*milliseconds
                            const oneDayMilliseconds = oneDay * 60 * 1000;

                            const firstDate = new Date(vm.display.endDate);
                            const secondDate = new Date(vm.display.orderEndDate);

                            const diffDays = Math.round(Math.abs((firstDate.getTime() - secondDate.getTime()) / (oneDayMilliseconds)));
                            var leadTime = parseInt(diffDays) * oneDay;

                            if (!utils.hasNoValue(vm.display.cutOffTime) && !utils.isEmpty(vm.display.cutOffTime)) {
                                var cutOffHour = vm.display.cutOffTime.getHours();
                                var cutOffMinute = vm.display.cutOffTime.getMinutes();

                                var minsInDay = parseInt(cutOffHour) * 60 + parseInt(cutOffMinute);

                                uploaded.availability.cutoffOffsetInMinutes = minsInDay - leadTime;
                            } else {
                                uploaded.availability.cutoffOffsetInMinutes = oneDay - 1 - leadTime; // Default
                                // To
                                // 23:59
                            }
                        } else {
                            uploaded.availability.cutoffOffsetInMinutes = ''; // Clear
                            // The
                            // Existing
                            // Cutoff
                        }
                    } else {
                        uploaded.availability.isPreorderable = true;
                        uploaded.availability.fixedPreorderType = false;

                        var leadTime = utils.hasNoValue(vm.display.leadTime) ? 0 : parseInt(vm.display.leadTime) * 24 * 60;
                        var minsInDay = 0;
                        if (!utils.hasNoValue(vm.display.cutOffTime)) {
                            var cutOffHour = vm.display.cutOffTime.getHours();
                            var cutOffMinute = vm.display.cutOffTime.getMinutes();
                            minsInDay = parseInt(cutOffHour) * 60 + parseInt(cutOffMinute);
                        }
                        if (!utils.hasNoValue(vm.display.cutOffTime) || !utils.hasNoValue(vm.display.leadTime)) {
                            uploaded.availability.cutoffOffsetInMinutes = minsInDay - leadTime;
                        }

                        if (!vm.holder.menuAlwaysAvailable) {
                            // Set up the list of days
                            const temp = [];
                            for (var i = 0; i < vm.days.length; i++) {
                                if (vm.days[i].selected)
                                    temp.push(vm.days[i].name);
                            }
                            uploaded.availability.orderDays = temp.join(',');

                            if (!utils.hasNoValue(vm.display.endDate))
                                uploaded.availability.expiryDateStr = utils.dateToServerDateString(vm.display.endDate);
                            else
                                uploaded.availability.expiryDateStr = null;

                            // Set up the list of blackoutdates
                            if (!utils.hasNoValue(vm.display.blackoutDateList)) {
                                const transformedBlackoutList = [];
                                for (var i = 0; i < vm.display.blackoutDateList.length; i++) {
                                    const d = utils.dateToServerDateString(vm.display.blackoutDateList[i]);
                                    transformedBlackoutList.push(d);
                                }

                                uploaded.availability.blackoutDates = transformedBlackoutList.join(',');
                            } else {
                                uploaded.availability.blackoutDates = null;
                            }
                        } else {
                            uploaded.availability.orderDays = null;
                            uploaded.availability.blackoutDates = null;
                            uploaded.availability.expiryDateStr = null;
                        }
                    }
                }
                if (uploaded.availability.cutoffOffsetInMinutes === 0) {
                    uploaded.availability.cutoffOffsetInMinutes = ''; // Clear the
                    // Existing
                    // Cutoff
                }

                uploaded.imageUrl = imageService.stripQueryString(uploaded.imageUrl);

                vm.uploadMenu = angular.copy(uploaded);
            };

            // Remove a no order date
            vm.removeDate = function (ind) {
                if (ind > -1) {
                    vm.display.blackoutDateList.splice(ind, 1);
                }
            };

            // Update the days that are enabled on the calendar
            vm.changeDayEnabled = function (day) {
                day.selected = !day.selected;
                vm.display.calendar_days_changed = !vm.display.calendar_days_changed;
            };

            vm.transformForRendering();

            // Save the menu
            vm.ok = function () {
                vm.transformForSaving();

                if (!vm.validateForm()) {
                    return;
                }
                vm.saving = true;
                if (vm.newMenu) {
                    menuService.createMenu(vm.uploadMenu).then((promise) => {
                        const r = formHelper.handleResponse(promise);

                        // If it was successful
                        if (r.isSuccess()) {
                            if (!vm.sharedMenu) {
                                const newProdGroup = promise.data;

                                menuService.setSelectedMenuId(newProdGroup.id);
                                menuService.selectedMenu = newProdGroup;

                                // Now we add the menu to our department
                                departmentService.addMenuToCurrentDepartment(newProdGroup).then((promise) => {
                                    vm.saveMenuCallback(promise);
                                }, (promise) => {
                                    vm.saveMenuCallback(promise);
                                });
                            } else {
                                vm.saving = false;
                                const newMenu = promise.data;
                                $uibModalInstance.close(newMenu);
                                vm.saveMenuCallback(promise);
                            }
                        } else
                            vm.saveMenuCallback(promise);
                    }, (promise) => {
                        vm.saveMenuCallback(promise);
                    });
                } else {
                    menuService.updateMenu(vm.uploadMenu).then((promise) => {
                        vm.saveMenuCallback(promise);
                        $uibModalInstance.close('updated');
                    }, (promise) => {
                        vm.saveMenuCallback(promise);
                    });
                }
            };
            // Cancel the update/crete
            vm.cancel = function () {
                $uibModalInstance.dismiss('cancel');
            };
            // Handle response from attempted save
            vm.removeMenuCallback = function (response) {
                const r = formHelper.handleResponse(response);
                if (r.isSuccess()) {
                    if (departmentService.getCurrentDepId()) {
                        menuService.loadMenus(departmentService.getCurrentDepId()).then((menuItemsResponse) => {
                            departmentService.clearDepartmentCache();
                            $rootScope.$broadcast('newMenus', menuItemsResponse);
                            $uibModalInstance.close('deleted');

                            messageService.saveAlert(gettextCatalog.getString('Menu Deleted'));
                        });
                    } else {
                        $rootScope.$broadcast('newMenus', response);
                        messageService.saveAlert(gettextCatalog.getString('Menu Deleted'));
                        $uibModalInstance.close('deleted');
                    }
                    $rootScope.$broadcast('reloadDashboard');
                }
            };

            vm.hideMenuType = function () {
                return merchantService.behaviour(merchantService.merchantInfo, 'editMenuPage.hideMenuType');
            };

            vm.hideAvailability = function () {
                if (vm.display.menuType) {
                    return merchantService.behaviour(merchantService.merchantInfo, 'editMenuPage.hideAvailability');
                } else {
                    return true;
                }
            };

            // Delete the menu
            vm.remove = function() {
                const confMsg = gettextCatalog.getString('Are you sure you want to delete this menu from Qkr?');

                const modalInstance = $uibModal.open({
                    template: require('../../templates/common/modalDialog.html'),
                    controller: 'commonModalDialogController',
                    windowClass: 'fade',
                    backdrop: 'static',
                    resolve: {
                        title() {
                            return gettextCatalog.getString('Delete menu');
                        },
                        confirmButtonName() {
                            return gettextCatalog.getString('Confirm');
                        },
                        confirmMsg() {
                            return confMsg;
                        },
                        multiMsgArray() {
                            return [];
                        }
                    }
                });

                modalInstance.result.then((result) => {
                    if (result == 'ok') {
                        menuService.deleteMenu(vm.currentMenu).then((promise) => {
                            vm.removeMenuCallback(promise);
                        }, (promise) => {
                            vm.removeMenuCallback(promise);
                        });
                    }
                }, () => {
                });
            };


            vm.availableOnDay = function(dayIndex) {
                const dIndex = ((7 - $rootScope.merchantInfo.contactDetails.country.weekStartingDay) + dayIndex) % 7;

                if (vm.days[dIndex].selected === false)
                    return false;

                return true;
            };

            vm.holder.minDate = new Date();
            vm.holder.minExpiryDate = utils.hasNoValue(vm.display.orderEndDate) ? vm.holder.minDate : vm.display.orderEndDate;

            // Change the minimum date on the Expiry date picker based on changing the
            // OrderEndDate
            vm.$watch('display.orderEndDate', () => {
                if (!utils.hasNoValue(vm.display.orderEndDate)) {
                    vm.holder.minExpiryDate = vm.holder.minDate > vm.display.orderEndDate ? vm.holder.minDate : vm.display.orderEndDate;
                }
            });

            vm.dateOptions = {
                startingDay: $rootScope.merchantInfo.contactDetails.country.weekStartingDay,
                showWeeks: false,
                showButtonBar: false
            };

            // Callback to check if a particular day is changeDayEnabled
            vm.disabled = function(date, mode) {
                if (mode === 'day' && typeof date !== 'undefined' && (!$scope.availableOnDay(date.getDay()))) {
                    return true;
                }
                return false;
            };
        });




// WEBPACK FOOTER //
// ./src/controllers/modal/menu.edit.controller.js